import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { NextImageWithLoader } from '@/components/NextImageWithLoader';
import { Typography } from '@/components/Typography';

import { ReactComponent as ChevronSvg } from '@/assets/icons/chevron.svg';

export const Wrapper = styled(Flex)`
  justify-content: center;

  ${({ theme }) => css`
    background-color: ${theme.colors.lightGrey};
    padding: 0 ${theme.spacing(2)};
    margin-top: ${theme.spacing(4)};

    ${theme.media.md.up} {
      margin-top: ${theme.spacing(8)};
      padding: 0;
    }
  `}
`;

export const InnerWrapper = styled(Flex)`
  align-items: center;
  flex-direction: column;

  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    padding: ${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(3)}
      ${theme.spacing(2)};

    ${theme.media.md.up} {
      background-color: ${({ theme }) => theme.colors.lightGrey};
      padding: ${theme.spacing(4)} 0 ${theme.spacing(4)} 0;
    }
  `}
`;

export const NftIcon = styled(NextImageWithLoader)`
  margin-bottom: 15px;
`;

export const Chevron = styled(ChevronSvg)`
  fill: ${({ theme }) => theme.colors.primary};
  height: 24px;
`;

export const SubHeader = styled(Typography)`
  text-transform: uppercase;
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  font-family: ${({ theme }) => theme.fontFamilies.italianPlate};
  color: ${({ theme }) => theme.colors.secondary};
  font-size: ${({ theme }) => theme.fontSizes.h6Mobile};

  ${({ theme }) => css`
    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.h5};
      font-weight: ${theme.fontWeights.bold};
    }
  `}
`;

export const Description = styled(Box)`
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.p2};
  line-height: ${({ theme }) => theme.lineHeights.p2};
  margin-bottom: ${({ theme }) => theme.spacing(2)};

  ${({ theme }) => css`
    ${theme.media.md.up} {
      max-width: 600px;
    }
  `}
`;

export const CTA = styled(LinkWithLocale)`
  display: flex;
  align-items: center;
  text-decoration: none;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primaryBlue};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: ${({ theme }) => theme.fontSizes.p2};
`;
